import React from 'react';
import { render } from 'react-snapshot';
import './index.css';
import App from './App';

if(typeof localStorage === 'undefined' && typeof global !== 'undefined') {
	//Pour la génération des pages
	global.localStorage = {}
}

render(<App />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js